import track from 'c9-tracking';
import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';
import { item as TrackingItem, consumers } from 'c9-tracking';
import { v4 as getUuid } from 'uuid';

const instanceId = getUuid();

/**
 * Get current consumers
 * Possible consumers: kibana, ga (Google Analytics), sas360
 * @returns
 */
const getCurrentConsumers = () => {
    return { consumers: [consumers.ga, consumers.kibana] };
};

export const trackInfo = (formConfig: FormConfig, payload: TrackingItem[]): void => {
    const payloadWithFormInfo = addFormDataToPayload(formConfig, payload);
    track.info(payloadWithFormInfo, instanceId, getCurrentConsumers());
    trackLocally('Info', payload);
};

export const trackConversion = (formConfig: FormConfig, payload: TrackingItem[]): void => {
    const payloadWithFormInfo = addFormDataToPayload(formConfig, payload);
    track.convert(payloadWithFormInfo, instanceId, getCurrentConsumers());
    trackLocally('Conversion', payload);
};

export const trackInteract = (formConfig: FormConfig, payload: TrackingItem[]): void => {
    const payloadWithFormInfo = addFormDataToPayload(formConfig, payload);
    track.interact(payloadWithFormInfo, instanceId, getCurrentConsumers());
    trackLocally('Interact', payload);
};

export const trackNavigate = (url: string, urlName: string): void => {
    track.navigate(url, urlName, instanceId, getCurrentConsumers());
    trackLocally('Navigation', { url, urlName });
};

const trackLocally = (trackingType: string, message: any): void => {
    if (!process.env.REACT_APP_TRACK_TO_CONSOLE || process.env.REACT_APP_TRACK_TO_CONSOLE === '0') {
        return;
    }
    console.debug('Tracked: ' + trackingType);
    console.debug(JSON.stringify(message, null, 4));
};

const addFormDataToPayload = (formConfig: FormConfig, payload: TrackingItem[]): TrackingItem[] => {
    const { formId, caption } = formConfig;
    payload.push({
        key: 'form-id',
        value: formId
    });

    payload.push({
        key: 'form-title',
        value: caption
    });
    return payload;
};
